import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        loadMore: 'getMoreExperiences'
      }
    };

    this.loadMore = null;
    this.experiencesList = null;
  }

  getMoreExperiences() {
    const offset = this.experiencesList.children.length;
    const label = this.loadMore.innerText;

    let total_pages, total_posts;

    this.loadMore.innerText = 'Cargando...';

    fetch( `${RSQ_XHR.api}wp/v2/posts?per_page=12&offset=${offset}`, {
      method: 'GET'
    } )
      .then( res => {
        //total_pages = res.headers.get('X-WP-TotalPages');
        total_posts = res.headers.get('X-WP-Total');
        return res.ok ? res.json() : Promise.reject(res)
      } )
      .then( data => {
        let currentList = this.experiencesList.innerHTML;

        for (let post in data) {
          currentList += `
          <article class="c-thumbnail -${ data[ post ].category.slug }">
            <div class="c-thumbnail_image">
                ${ data[ post ].thumbnail.rendered }
            </div>
            <a class="c-thumbnail_link" href="${ data[ post ].link }">
              <h2 class="c-thumbnail_heading">
                <span class="o-gradient-text">${ data[ post ].title.rendered }</span>
              </h2>
              <p class="c-thumbnail_category | o-button">
                <span class="o-gradient-text">${ data[ post ].category.name }</span>
              </p>
            </a>
          </article>
          `;
        }

        this.loadMore.innerText = label;

        if ( total_posts > offset + data.length ) {
          this.loadMore.classList.remove('u-hidden');
        } else {
          this.loadMore.classList.add('u-hidden');
        }

        this.experiencesList.innerHTML = currentList;
      } )
      .catch( error => {
        throw Error( error.message );
      } )
    ;

  }

  init( event ) {
    this.loadMore = this.$('loadMore')[0];
    this.experiencesList = this.$('list')[0];
  }
}
